import React, { useEffect, useState } from "react";
import bannerImage from "../img/aaaservices/mob-bg.jpg";

const Banner = () => {
  const [animate, setAnimate] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const handleOpenForm = () => setShowForm(true);
  const handleCloseForm = () => setShowForm(false);

  useEffect(() => {
    setAnimate(true);
  }, []);

  return (
    <>
      <style>{`
        .banner-container {
          position: relative;
          width: 100%;
          height: 112vh;
          max-height: 762px;
          overflow: hidden;
        }

        .banner-image {
          width: 100%;
          height: 112vh;
          max-height:762px;
          object-fit: cover;
        }

        .banner-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          z-index: 1;
        }

        .banner-text {
          position: absolute;
          bottom: 20%;
          left: 5%;
          color: white;
          z-index: 2;
          opacity: 0;
          transform: translateY(50px);
          transition: all 1s ease-out;
          max-width: 700px;
        }

        .banner-text.animate {
          opacity: 1;
          transform: translateY(0);
        }

        .banner-heading {
          font-size: 2.5rem;
          font-weight: 700;
          margin: 0;
        }

        .banner-heading .blue {
          color: white;
          text-transform: uppercase;
        }

        .banner-heading span:last-child {
          color: gold;
        }

        .banner-subheading {
          font-size: 1.125rem;
          font-weight: 400;
          margin-top: 15px;
          line-height: 1.6;
          text-align: left;
          max-width: 600px;
        }

        .banner-text button {
          margin-top: 20px;
          background-color: #FACC15;
          color: black;
          padding: 12px 24px;
          border-radius: 9999px;
          border: none;
          font-weight: 600;
          cursor: pointer;
        }

        @media screen and (max-width: 768px) {
          .banner-heading {
            font-size: 2rem;
          }

          .banner-subheading {
            font-size: 1rem;
            max-width: 90%;
          }
        }

        @media screen and (max-width: 480px) {
          .banner-heading {
            font-size: 1.5rem;
          }

          .banner-subheading {
            font-size: 0.875rem;
          }
        }

        .overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }

        .modal {
          background-color: #fff;
          padding: 30px;
          border-radius: 12px;
          width: 90%;
          max-width: 400px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
          position: relative;
        }

        .modal h3 {
          margin-bottom: 20px;
          color: rgb(12 133 155);
        }

        .modal input {
          width: 100%;
          padding: 10px;
          margin-bottom: 12px;
          border-radius: 6px;
          border: 1px solid #ccc;
        }

        .modal .submit-button {
          background-color: #FACC15;
          color: #fff;
          padding: 10px;
          border: none;
          border-radius: 6px;
          width: 100%;
          font-weight: bold;
          cursor: pointer;
          margin-top: 10px;
        }

        .modal .close-button {
          position: absolute;
          top: 10px;
          right: 10px;
          background: transparent;
          border: none;
          font-size: 18px;
          cursor: pointer;
        }
      `}</style>

      <div className="banner-container">
        <img src={bannerImage} alt="Banner" className="banner-image" />
        <div className="banner-overlay"></div>
        <div className={`banner-text ${animate ? "animate" : ""}`}>
          <h1 className="banner-heading">
            <span className="blue">Mobile </span>
            <span> APPLICATION</span>
          </h1>
          <p className="banner-subheading">
            Mobile applications have become an integral part of modern life,
            serving various needs from personal productivity to entertainment
            and social interaction. Successful app development requires careful
            planning, a deep understanding of user needs, and a commitment to
            delivering high-quality, engaging experiences. With the rapid
            advancements in technology, the potential for innovative and
            impactful mobile apps continues to grow.
          </p>
        </div>

        {showForm && (
          <div className="overlay">
            <div className="modal">
              <h3>Welcome to Envision Group</h3>
              <input type="text" placeholder="Name" />
              <input type="email" placeholder="Email" />
              <input type="tel" placeholder="Mobile" />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Banner;
